(function(){
  function init() {
    const wrapper = document.querySelector('[data-mobile-sticky-add-to-cart]');
    if (!wrapper) return;

    const section = wrapper.closest('.main-product-section') || document.querySelector('.main-product-section');
    if (!section) return;

    const mainForm = section.querySelector('form.product-single__form, form.product__form');
    const mainAddBtn = mainForm?.querySelector('[data-add-to-cart]');
    const stickyBtn = wrapper.querySelector('[data-mobile-sticky-add-to-cart-button]');
    const stickyText = wrapper.querySelector('[data-mobile-sticky-add-to-cart-text]');
    const isOnlyOneVariant = stickyBtn?.dataset.isOnlyOneVariant === 'true';
    const isAvailable = stickyBtn?.dataset.isAvailable === 'true';
    const singleVariantId = stickyBtn?.dataset.singleVariantId;
    const isComingSoon = stickyBtn?.dataset.isComingSoon === 'true';

    function getSelectedId(){ return mainForm?.querySelector('[name="id"]')?.value || ''; }

   function update(){
  const id = getSelectedId();
  const has = Boolean(id);
  const disabled = !has || mainAddBtn?.disabled === true;
  
  // For single variant products, never show "select size"
  if (isOnlyOneVariant) {
    const mainBtnText = mainAddBtn?.querySelector('[data-add-to-cart-text]')?.textContent.trim();
    const fallbackText = stickyText.dataset.defaultText;
    const isUnavailable = mainAddBtn?.disabled === true;
    
    stickyBtn.disabled = isUnavailable;
    const displayText = isUnavailable && mainBtnText != 'Select size'
      ? stickyText.dataset.soldOutText 
      : (mainBtnText || fallbackText);
    stickyBtn.setAttribute('aria-label', displayText);
    stickyText.textContent = displayText;
    return;
  }
  if (isComingSoon && !isAvailable ) {
    stickyBtn.disabled = false;
    stickyBtn.setAttribute('aria-label', stickyBtn.dataset.comingSoonText || 'Coming Soon');
    stickyText.textContent = stickyBtn.dataset.comingSoonText || 'Coming Soon';
    return;

  }

  // Multi-variant logic (original)
  stickyBtn.disabled = disabled;
  stickyBtn.setAttribute('aria-label', has 
    ? (mainAddBtn?.querySelector('[data-add-to-cart-text]')?.textContent.trim() || stickyText.dataset.defaultText) 
    : stickyText.dataset.selectText);
  stickyText.textContent = has 
    ? (mainAddBtn?.querySelector('[data-add-to-cart-text]')?.textContent.trim() || stickyText.dataset.defaultText) 
    : stickyText.dataset.selectText;
}

    stickyBtn.addEventListener('click', function(e){
        if (isComingSoon && !isAvailable ) {
                    const comingSoonText = stickyBtn.dataset.comingSoonText || 'Coming Soon';

          const comingSoonBtn = section.querySelector('a.BIS_trigger.backInStockLink.btn.product-block.btn--primary.btn--full');
          comingSoonBtn.click();
  }
            // Single variant — skip id guard, only block if unavailable
     if (isOnlyOneVariant) {
        if (!isAvailable) return;
      mainAddBtn.click();
        return;
      }

      // Multi-variant — scroll to selector if no id chosen

      const id = getSelectedId();
      if (!id || mainAddBtn?.disabled) { e.preventDefault(); const first = mainForm.querySelector('select[name="id"], [data-variant-input]'); if (first){ first.scrollIntoView({behavior:'smooth', block:'center'}); first.focus({preventScroll:true}) } else mainForm.scrollIntoView({behavior:'smooth', block:'center'}); return }
      mainAddBtn.click();
    });

    if (mainForm) mainForm.addEventListener('change', update);

    // Observe the actual add button so sticky shows only after it's scrolled past
    const target = mainForm.querySelector('[data-add-to-cart], .buy_buttons') || mainForm;
    if (target && window.IntersectionObserver) {
      const obs = new IntersectionObserver(function(entries){
        const visible = entries.some(e=>e.isIntersecting);
        wrapper.classList.toggle('mobile-sticky-add-to-cart--visible', !visible);
        if (!visible) update();
      },{ rootMargin: '0px 0px -90px 0px', threshold: 0 });
      obs.observe(target);
    }

    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
